// Separated from db.ts so frontend code can import JobStatus
// without pulling in Node.js-only dependencies (pg, zapatos).
export enum JobStatus {
  Queued = "queued",
  Processing = "processing",
  Success = "finished",
  Failed = "failed",
  Cancelling = "cancelling",
  Cancelled = "cancelled",
}

// Kept here (rather than db.ts) so frontend code can import it without
// pulling in the Node.js-only dependencies db.ts carries.
export const TERMINAL_JOB_STATES = [
  JobStatus.Cancelled,
  JobStatus.Failed,
  JobStatus.Success,
];
